import { apiClient } from "../apiClient";

const startPaymentTPay = (orderId, idempotencyKey) => {
    return apiClient.post(
        `/orders/${orderId}/payments/tpay`,
        {},
        {
            headers: {
                "Content-Type": "application/json",
                ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
            },
        }
    );
};

const downloadTicket = async (id, token) => {
    const response = await apiClient.get(`/tickets/${id}/download?token=${token}`, {
        responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
};

const create = ({ eventId, buyer, items, freeQuantity, participants, idempotencyKey, discountCode }) =>
    apiClient.post(`/orders`, {
        eventId,
        buyer,
        items,
        freeQuantity,
        participants,
        idempotencyKey,
        discountCode,
    }, {
        headers: {
            "Content-Type": "application/json",
            "X-Idempotency-Key": idempotencyKey
        }
    }).then(r => r.data);

const getStatus = (orderId) =>
    apiClient.get(`/orders/${orderId}/status`).then(r => r.data);

export default {
    startPaymentTPay,
    downloadTicket,
    create,
    getStatus
};
